import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent implements OnInit {
  @Input() buttonText: string;
  @Input() description: string;
  @Input() image: string;
  @Input() link: string;
  @Input() title: string;

  constructor() { }

  ngOnInit(): void {
  }

}
